/**
 * 微信「获取小程序备案状态及驳回原因」info.status。
 * https://developers.weixin.qq.com/doc/oplatform/openApi/miniprogram-management/record/api_geticpentranceinfo.html
 */
export const ICP_ENTRANCE_STATUS = {
  2: "平台审核中",
  3: "平台审核驳回",
  4: "管局审核中",
  5: "管局审核驳回",
  6: "已备案",
  1024: "未备案",
  1025: "未备案 && 小程序信息未填",
  1026: "未备案 && 小程序类目未填",
  1027: "未备案 && 小程序信息未填 && 小程序类目未填",
  1028: "未备案 && 小程序未认证",
  1029: "未备案 && 小程序信息未填 && 小程序未认证",
  1030: "未备案 && 小程序类目未填 && 小程序未认证",
  1031: "未备案 && 小程序信息未填 && 小程序类目未填 && 小程序未认证",
};

/** 仅 status=4 时有效 */
export const ICP_SMS_VERIFY_STATUS = {
  1: "等待核验中",
  2: "核验完成",
  3: "核验超时",
};

export function parseWeixinInt(value) {
  if (value === undefined || value === null || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function icpStatusTone(status) {
  if (status === 6) return "success";
  if (status === 2 || status === 4) return "warning";
  if (status === 3 || status === 5) return "danger";
  if (status != null && status >= 1025 && status <= 1031) return "warning";
  if (status === 1024) return "info";
  return "info";
}

export function normalizeIcpAuditData(info) {
  if (!info || !Array.isArray(info.audit_data)) return [];
  return info.audit_data
    .filter((item) => item && typeof item === "object")
    .map((item) => ({
      keyName: item.key_name ? String(item.key_name) : "",
      error: item.error ? String(item.error) : "",
      suggest: item.suggest ? String(item.suggest) : "",
    }));
}

/** 把 geticpstatus 的返回解析成可展示的备案状态。 */
export function describeIcpEntrance(raw) {
  const empty = {
    label: "",
    tone: "info",
    canceling: false,
    available: "",
    sms: "",
    auditItems: [],
    error: "",
  };
  if (!raw || typeof raw !== "object") return empty;
  const payload =
    raw.data &&
    typeof raw.data === "object" &&
    (raw.data.errcode !== undefined || raw.data.info !== undefined)
      ? raw.data
      : raw;
  const errcode = parseWeixinInt(payload.errcode);
  const info =
    payload.info && typeof payload.info === "object" && !Array.isArray(payload.info)
      ? payload.info
      : null;
  const status = parseWeixinInt(info ? info.status : null);
  const auditItems = normalizeIcpAuditData(info);
  if (errcode != null && errcode !== 0 && status == null) {
    return {
      ...empty,
      label: payload.errmsg || "查询备案状态失败",
      tone: "danger",
      error: payload.errmsg || "查询备案状态失败",
      auditItems,
    };
  }
  const label = status != null ? ICP_ENTRANCE_STATUS[status] || "已返回备案状态" : "暂无备案状态";
  const smsCode = parseWeixinInt(info ? info.sms_verify_status : null);
  const available = parseWeixinInt(info ? info.available : null);
  return {
    label,
    tone: icpStatusTone(status),
    canceling: Boolean(info && info.is_canceling),
    available:
      available === 1 ? "开放" : available === 0 ? "未开放" : "",
    sms: status === 4 && smsCode != null ? ICP_SMS_VERIFY_STATUS[smsCode] || "" : "",
    auditItems,
    error: "",
  };
}
